import { render } from "./ItemModificationRow.vue?vue&type=template&id=363a84de"
import script from "./ItemModificationRow.vue?vue&type=script&lang=js"
export * from "./ItemModificationRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__